<template>
    <section v-if="localTrack" class="track_metadata_panel">
        <span class="text_sec">{{ $t('metadata.trackOrder') }}</span><br>
        <input
            class="input_thing"
            :value="localTrack?.num"
            @change="updateTrackField('num', $event.target.value)"
            type="number"
        >
        <span class="text_sec">{{ $t('metadata.artist') }}</span><br>
        <input
            class="input_thing"
            :value="localTrack?.artist"
            @change="updateTrackField('artist', $event.target.value)"
            type="text"
        >
        <span class="text_sec">{{ $t('metadata.name') }}</span><br>
        <input
            class="input_thing"
            :value="localTrack?.name"
            @change="updateTrackField('name', $event.target.value)"
            type="text"
        >
        <span class="text_sec">BPM</span><br>
        <input
            class="input_thing"
            :value="localTrack?.bpm"
            @change="updateTrackField('bpm', $event.target.value)"
            type="number"
        >
        <div class="row">
            <div class="col-6">
                <span class="text_sec">{{ $t('metadata.key') }}</span><br>
                <select
                    class="input_thing"
                    :value="localTrack?.key ?? 'null'"
                    @change="updateTrackField('key', $event.target.value)"
                >
                    <option value="null">{{ $t('common.none') }}</option>
                    <option v-for="key in scales" :value="key" v-bind:key="key">{{ key }}</option>
                </select>
            </div>
            <div class="col-6">
                <span class="text_sec">{{ $t('metadata.mode') }}</span><br>
                <select
                    class="input_thing"
                    :value="localTrack?.mode ?? 'null'"
                    @change="updateTrackField('mode', $event.target.value)"
                >
                    <option value="null">{{ $t('common.none') }}</option>
                    <option v-for="mode in modes" :value="mode" v-bind:key="mode">{{ mode }}</option>
                </select>
            </div>
        </div>
        <span v-if="metadataSaveError" class="metadata_save_error">{{ metadataSaveError }}</span>
        <button
            v-if="showDelete && storageType !== 'shared'"
            class="btn-new btn_danger mt-4"
            type="button"
            @click="deleteTrack"
        >
            {{ $t('metadata.deleteTrack') }}
        </button>
    </section>
</template>

<script>
import storageService from '@/scripts/services/StorageService';

export default {
    name: 'TrackMetadataPanel',
    props: {
        track: {
            type: Object,
            default: null
        },
        showDelete: {
            type: Boolean,
            default: false
        }
    },
    emits: ['updated', 'deleted'],
    data() {
        return {
            localTrack: null,
            scales: ['C', 'Cb', 'C#', 'D', 'Db', 'D#', 'E', 'Eb', 'F', 'F#', 'G', 'Gb', 'G#', 'A', 'Ab', 'A#', 'B', 'Bb'],
            modes: ['major', 'minor'],
            metadataSaveError: ''
        };
    },
    watch: {
        track: {
            handler(newTrack) {
                this.localTrack = newTrack ? { ...newTrack } : null;
            },
            immediate: true
        }
    },
    computed: {
        storageType() {
            return storageService.state.storageType;
        }
    },
    methods: {
        async updateTrackField(field, value) {
            if (!this.localTrack) return;

            const updatedTrack = { ...this.localTrack };
            if (field === 'bpm' || field === 'num') {
                updatedTrack[field] = value === '' ? null : Number(value);
            } else if (value === 'null') {
                updatedTrack[field] = null;
            } else {
                updatedTrack[field] = value;
            }

            this.localTrack = updatedTrack;
            this.metadataSaveError = '';
            const saved = await storageService.updateTrack(updatedTrack);
            if (saved) {
                const savedTrack = storageService.getTrackById(updatedTrack.id) || updatedTrack;
                this.$emit('updated', savedTrack);
            } else {
                this.metadataSaveError = this.$t('metadata.saveError');
            }
        },
        async deleteTrack() {
            if (!this.track || this.storageType === 'shared') return;
            if (confirm(this.$t('trackItem.confirmDelete'))) {
                const deleted = await storageService.deleteTrack(this.track.id);
                if (deleted) {
                    this.$emit('deleted', this.track.id);
                }
            }
        }
    }
};
</script>

<style scoped>
.track_metadata_panel {
  min-height: 100%;
}

.track_metadata_panel .input_thing {
  margin-bottom: 0.75rem;
}

.metadata_save_error {
  display: block;
  margin-top: 0.75rem;
  color: #ff8e8e;
  font-size: 0.875rem;
}
</style>
